import type { GetObservationRelatedItemsTypesProps } from "./observation-delete-related-items.type";

import uniq from "lodash/uniq";

export const getObservationRelatedItemsTypes = ({
  datasets,
  comments,
  recommendation,
  interventions,
}: GetObservationRelatedItemsTypesProps): string[] => {
  const datasetTypes = uniq(datasets.map((dataset) => dataset.type));

  const itemsTypes: string[] = [...datasetTypes];

  if (comments.length) itemsTypes.push("comment");
  if (recommendation) itemsTypes.push("recommendation");
  if (interventions.length) itemsTypes.push("interventions");

  return itemsTypes;
};
